<div class="contacto">
	<!-- <div class="fondo-purple">
		<a href="tel:5570309015">
			<figure>
				<img src="assets/images/iconos/ico-cel.svg" alt="Teléfono Pawerful Pet Shop">
			</figure>
			<p class="color-white">(55) 7030 90 15</p>
		</a>
	</div> -->
	<div class="fondo-purple">
		<a href="http://ivt.mx/e7XFv" target="_blank">
			<figure>
				<img src="assets/images/iconos/ico-whatsapp.webp" alt="WhatsApp Pawerful Pet Shop" loading="lazy"/>
			</figure>
			<p class="color-white">(56) 2165 6563</p>
		</a>
	</div>
	<div class="fondo-blue">
		<a href="mailto:contacto@pawerful.com">
			<figure>
				<img src="assets/images/iconos/ico-mail.webp" alt="Correo electrónico Pawerful Pet Shop" loading="lazy"/>
			</figure>
			<p class="color-white">contacto@pawerful.com</p>
		</a>
	</div>
</div>